import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from 'src/components/Button';
import './style.scoped.css';
import { useHistory } from 'react-router-dom';
import policySt, { PolicyStore } from 'src/stores/PolicyStore';
import { observer } from 'mobx-react-lite';
import IconTick from 'src/assets/icon_tick.svg';


interface CompleteCancelObserverProps {
  policyStore?: PolicyStore;
}

const CompleteCancelObserver = observer(({ policyStore }: CompleteCancelObserverProps) => {
  const { t } = useTranslation();
  const history = useHistory();

  const _handleButton = () => {
    history.push("/");
  };

  return (
    <div className="screen-container bg-background view-complete-cancel">
      <div className="max-w-md mx-auto">
        <div className="relative w-full max-w-md m-auto flex-col flex rounded-lg items-center">
          <div className='logo'>
            <img src={IconTick} className="w-20 h-20" />
          </div>
        </div>
        <div>
          <p className="title text-center">{t('complete_cancel_title')}</p>
        </div>
        <div className="content text-center">
          <div dangerouslySetInnerHTML={{ __html: t('complete_cancel_content_1', { policyNum: policyStore.policyToCancel?.policyNum }) }}></div>
          <div className='pt-6' dangerouslySetInnerHTML={{ __html: t('complete_cancel_content_2') }}></div>
        </div>
      </div>
      <div className="bottomButtonBlock">
        <Button
          text={t('completed')}
          onClick={_handleButton}
          extraClassName={'w-full'}
        />
      </div>
    </div>
  );
});

const CompleteCancel = () => <CompleteCancelObserver policyStore={policySt} />;
export default CompleteCancel;
